import 'core-js';
import '@hooked74/events-polyfill';
import 'whatwg-fetch'
import 'formdata-polyfill';
import 'url-search-params-polyfill';
import 'polyfill-nodelist-foreach';
import '@splidejs/splide/css/core';
import '@utils/accessibility/modal'


import { HeaderScrollHandler } from './component/layout/header-scrollHandler';
import { headNav } from './component/layout/head-nav';
import { headTools } from './component/layout/head-tools';
import { modals } from './component/layout/modals';
import { Slider } from './component/global/splide';
import { Widgets } from './component/global/widgets';
import { Energylabel } from './component/global/energylabel';
import { errorLog } from './component/global/error-log';
import { Authentication } from './component/global/auth';
import { SmartSupply } from "./component/myshop/smart-supply";
import {
    addEnterAndSpaceHandler, enableKeyboardClickSupportForClass,
    removeEnterAndSpaceHandler,
    setupSkipToContent, setupSkipToSearchresult,
} from "@utils/accessibility/general";
import {setupSplideAriaLabels} from "@utils/accessibility/slider";
import {setupPuesAccessibility} from "@utils/accessibility/pues";
import "./utilities/accessibility/modal"
import {setupFocusTraps} from "@utils/accessibility/focusTrap";
import {addChangeEventFooterMenu} from "@utils/accessibility/footer";
import "@utils/accessibility/iframe";
import {setupCustomDropdown} from "@utils/accessibility/dropdown";
import "@utils/accessibility/header";

let hNav = new headNav();
let hTools = new headTools();
let mdls = new modals();
let slider = new Slider();
let widgets = new Widgets();
let energylabel = new Energylabel();
let error = new errorLog();
let auth = new Authentication();

new HeaderScrollHandler();
hNav.init();
hTools.init();
mdls.init();
slider.init();
widgets.init();
energylabel.init();
error.init();
auth.init();

new SmartSupply();

document.addEventListener('DOMContentLoaded', function() {
    setupSkipToContent();
    setupSkipToSearchresult();
    removeEnterAndSpaceHandler();
    addEnterAndSpaceHandler();
    enableKeyboardClickSupportForClass(); // adds click-support for '.keyboard-clickable' (use for eg. checkboxes)
    setupCustomDropdown();
    setupSplideAriaLabels();
    setupPuesAccessibility();
    addChangeEventFooterMenu();
    setupFocusTraps()
}, { once: true });
